module.exports = __webpack_public_path__ + "img/Headband.ac15cb29.jpg";